import { GlobalErrorBoundary, LocationConfigProvider, ThemeProvider, Toaster } from '@unipile/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Layout from './components/common/Layout';
import { queryClient } from './libs/react-query';

type Props = {
  children: React.ReactNode;
};

export function AppProvider({ children }: Props) {
  return (
    <GlobalErrorBoundary>
      <ThemeProvider defaultTheme="light" storageKey="ui-theme">
        <QueryClientProvider client={queryClient}>
          <LocationConfigProvider>
            <Layout>
              {import.meta.env.DEV && <ReactQueryDevtools />}
              <Toaster />
              {children}
            </Layout>
          </LocationConfigProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </GlobalErrorBoundary>
  );
}
